import classNames from 'classnames';
import { LoaderBars } from '@aleph/shared-components';
import React from 'react';

const AdvertiserOverlayLoader = () => (
	<div
		className={
			classNames(
				'flex-1 pl-[40px] pr-[20px] flex overflow-y-hidden flex-col gap-[24px] h-[100vh] w-full absolute top-0 left-0 z-[100] backdrop-blur-lg',
			)
		}
		style={{ backgroundImage: 'linear-gradient(90deg, transparent 5%, white 30%, white 70%, transparent 95%)' }}
	>
		<div className="flex h-[63px] border-b border-b-black justify-between items-center gap-[16px] text-[18px]">
			<div className="flex items-center gap-[16px]">
				<LoaderBars
					width={32}
					height={32}
					className="animate-spin"
				/>

				<div>Loading advertiser...</div>
			</div>
		</div>
	</div>
);

export default AdvertiserOverlayLoader;
